export const gridDimensionsSelector = state => state.dimensions;